import Vue from 'vue'
import ProfileDetail from './components/profile-detail.vue'
import PurchaseHistory from './components/purchase-history.vue'
import { corpMixins } from '@/mixins/corp-mixins'

export default Vue.extend({
  name: 'Profile',
  mixins: [corpMixins],
  data() {
    return {}
  },
  components: {
    ProfileDetail,
    PurchaseHistory
  },
  mounted() {
    const elm = document.getElementsByClassName('main-panel')[0]
    // @ts-ignore
    elm.style.setProperty('background-color', 'rgba(255,255,255,0.8)', 'important')
  },
  beforeDestroy() {
    const elm = document.getElementsByClassName('main-panel')[0]
    // @ts-ignore
    elm.style.setProperty('background-color', 'transparent', 'important')
  }
})
